import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export const CTASection = () => {
  const { language } = useLanguage();
  const { ref, isVisible } = useScrollAnimation();

  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      ref={ref}
      className="py-24 md:py-32 bg-white dark:bg-slate-900 theme-transition"
      data-testid="cta-section"
    >
      <div className="section-container">
        <div 
          className={`relative overflow-hidden rounded-3xl bg-gradient-to-br from-indigo-600 to-violet-600 p-12 md:p-16 text-center ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}
        >
          {/* Background Pattern */}
          <div 
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          />

          <div className="relative z-10">
            <h2 
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 tracking-tight"
              data-testid="cta-title"
            >
              {translations.cta.title[language]}
            </h2>
            <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
              {translations.cta.subtitle[language]}
            </p>
            <Button
              onClick={scrollToContact}
              className="rounded-full bg-white text-indigo-600 hover:bg-slate-100 px-8 py-6 text-lg font-semibold shadow-2xl hover:scale-105 transition-all inline-flex items-center gap-2"
              data-testid="cta-button"
            >
              {translations.cta.button[language]}
              <ArrowRight className="w-5 h-5" strokeWidth={1.5} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
